define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../utils/LookupDataSources", "../../models/ProjectManagerModel", "../../models/ManagerDeleteModel", "../../models/UserContext"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, LookupDataSources, ProjectManagerModel, ManagerDeleteModel, UserContext) {
    "use strict";
    var ProjectManagers = /** @class */ (function () {
        function ProjectManagers() {
            this.editModel = ko.observable(new ProjectManagerModel());
            this.deleteManagerModel = ko.observable(new ManagerDeleteModel());
            this.clearFilterInProgress = false;
            this.filterByAny = ko.observable("");
        }
        ProjectManagers.prototype.init = function () {
            var self = this;
            $("#page-title").text("Project Managers");
            tools.ajaxGet({
                url: "/ProjectManager/GetProjectManagersLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initProjectManagers(self.lookupLists.GridStructures.ProjectManagerStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        ProjectManagers.prototype.initProjectManagers = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "100px",
                sortable: false,
                template: function (dataItem) {
                    var html = "";
                    html += '<div style="text-align:center"><a class="btn btn-info btn-edit btn-sm" title="Edit" href="#"><i class="fa fa-edit " ></i></a>';
                    html += '&nbsp;<a class="btn btn-danger btn-remove btn-sm" title="Delete" href="#"><i class="fa fa-trash-o"></i></a></div>';
                    return html;
                }
            });
            var gridId = "projectManagersTable";
            self.ProjectManagerTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                gridOptions: {
                    columns: columns,
                    autoBind: true,
                    resizable: true,
                    //reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row menu",
                        extra: false
                    }
                },
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/ProjectManager/GetProjectManagers",
                            type: "POST",
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total"
                    }
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "ProjectManager",
                    title: "Project Managers",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.ProjectManagerTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.ProjectManagerTable.refresh();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editProjectManager(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.deleteProjectManagerConfirm(data.Id, data.Name);
                event.preventDefault();
            });
        };
        ProjectManagers.prototype.editProjectManager = function (id) {
            var self = this;
            var title = id > 0 ? "Edit Project Manager" : "Add Project Manager";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error("Name is required");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveProjectManager(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/ProjectManager/GetProjectManagerById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new ProjectManagerModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new ProjectManagerModel());
                    }
                    $.when(getModelCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'project-manager-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        ProjectManagers.prototype.saveProjectManager = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = ko.mapping.toJS(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/ProjectManager/SaveProjectManager",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    _this.ProjectManagerTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        ProjectManagers.prototype.deleteProjectManagerConfirm = function (id, name) {
            var self = this;
            self.deleteManagerModel(new ManagerDeleteModel());
            self.deleteManagerModel().Id(id);
            self.deleteManagerModel().Name(name);
            self.deleteManagerModel().DeleteLabel("Are you sure you want to delete Project Manager?");
            self.deleteManagerModel().NewCustomerLabel("New Project Manager For Customers");
            tools.editModal({
                title: "Delete Project Manager - ".concat(name),
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.deleteProjectManager(event.currentTarget, modal);
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'manager-remove-template', data: deleteManagerModel }\"></div>");
                    ko.applyBindings(self, modal);
                    var lookupDataSources = new LookupDataSources();
                    var dataSource = lookupDataSources.createLookupDataSource("ProjectManagers");
                    self.newProjectManagerId = $("input[name=NewId]", modal).kendoDropDownList({
                        dataSource: dataSource,
                        optionLabel: "Select Project Manager",
                        dataTextField: "Text",
                        dataValueField: "Id",
                        valuePrimitive: true,
                        filter: "contains",
                        popup: {
                            appendTo: modal
                        }
                    }).data("kendoDropDownList");
                }
            });
        };
        ProjectManagers.prototype.deleteProjectManager = function (btn, modal) {
            var self = this;
            var data = {
                id: self.deleteManagerModel().Id(),
                newId: self.newProjectManagerId.value()
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/ProjectManager/DeleteProjectManagerConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Project manager deleted successfully");
                    self.ProjectManagerTable.refresh();
                    $(modal).modal("hide");
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        ProjectManagers.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
        };
        ProjectManagers.prototype.exportTo = function () {
            var self = this;
            self.ProjectManagerTable.exportTo();
        };
        ProjectManagers.prototype.initLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("ProjectManager");
                dataLogs.initKendoLogs("divLogsTable");
            }
        };
        return ProjectManagers;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/ProjectManager/Index")) {
            log.log("Initialize Project Managers");
            $(function () {
                (new ProjectManagers()).init();
            });
        }
    }, 0);
    return ProjectManagers;
});
//# sourceMappingURL=projectManagers.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/settings/projectManagers.js
// module id = 228
// module chunks = 2